import { http, HttpResponse, RequestHandler } from 'msw'

import { getApiRoute } from '@core/utils/api'

import { getClubSponsorsConfig } from '@services/Sponsors/api'

import { sponsorsList } from './mock'

export const getSponsorsHandler: RequestHandler = http.get(
  getApiRoute<{ clubHash: string }>(getClubSponsorsConfig.url, { params: { clubHash: '*' } }),
  () => HttpResponse.json(sponsorsList),
)
